<template>
  <el-dialog
    title="借用申请"
    :visible.sync="visible"
    width="560px"
    append-to-body
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-if="toolRow" class="task-info-bar">
      <span class="label">工具名称：</span>
      <span class="value">{{ toolRow.toolName }}</span>
      <span class="label" style="margin-left:16px">编号：</span>
      <span class="value">{{ toolRow.toolCode }}</span>
      <span class="label" style="margin-left:16px">可用数量：</span>
      <span class="value" :class="availableClass">{{ toolRow.availableCount }} / {{ toolRow.totalCount }}</span>
      <span v-if="toolRow.availableCount <= 0" class="value" style="margin-left:16px; color:#e6a23c">可用数量不足，无法借用</span>
    </div>
    <el-form ref="form" :model="form" :rules="rules" label-width="110px">
      <el-form-item label="借用数量" prop="borrowCount">
        <el-input-number
          v-model="form.borrowCount"
          :min="1"
          :max="toolRow ? toolRow.availableCount : 9999"
          :precision="0"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="预计归还时间" prop="expectReturnTime">
        <el-date-picker
          v-model="form.expectReturnTime"
          type="datetime"
          placeholder="请选择预计归还时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          style="width: 100%"
        />
      </el-form-item>
      <el-form-item label="用途说明" prop="purpose">
        <el-input
          v-model="form.purpose"
          type="textarea"
          :rows="3"
          placeholder="请填写借用用途（必填）"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" :disabled="!toolRow || toolRow.availableCount <= 0" @click="handleSubmit">提交申请</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { toolService } from './tool.service';

export default {
  name: 'BorrowApplyDialog',
  data() {
    return {
      visible: false,
      loading: false,
      toolRow: null,
      form: {
        toolId: '',
        borrowCount: 1,
        expectReturnTime: '',
        purpose: '',
        remark: ''
      },
      rules: {
        borrowCount: [{ required: true, message: '请输入借用数量', trigger: 'blur' }],
        purpose: [{ required: true, message: '请填写用途说明', trigger: 'blur' }]
      }
    };
  },
  computed: {
    availableClass () {
      if (!this.toolRow) return '';
      const denom = this.toolRow.totalCount || 1;
      const ratio = this.toolRow.availableCount / denom;
      if (ratio >= 0.6) return 'count-success';
      if (ratio >= 0.2) return 'count-warning';
      return 'count-danger';
    }
  },
  methods: {
    open(row) {
      if (!row) return;
      this.visible = true;
      this.toolRow = row;
      this.form = { toolId: row.uuid, borrowCount: 1, expectReturnTime: '', purpose: '', remark: '' };
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate());
    },
    handleClose() {
      this.visible = false;
      this.toolRow = null;
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.loading = true;
        toolService.applyBorrow(this.form).then(() => {
          this.$message.success('借用申请已提交，等待审批');
          this.handleClose();
          this.$emit('success');
        }).finally(() => {
          this.loading = false;
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.task-info-bar {
  background: #f5f7fa;
  border-radius: 4px;
  padding: 10px 14px;
  margin-bottom: 16px;
  font-size: 13px;
  color: #606266;

  .label { color: #909399; }
  .value { font-weight: 500; }
}

.count-success { color: #67c23a; font-weight: 600; }
.count-warning { color: #e6a23c; font-weight: 600; }
.count-danger { color: #f56c6c; font-weight: 600; }
</style>
